namespace $.$$ {

	$mol_style_define( $shm_hitalama_settings_transfer, {

		Import_all: {
			overflow: 'hidden',
			Native: {
				top: 0,
				height: '100%',
			},
		},

	} )

}
